:host {
  display: block;
}
.dynamic-entry-error {
  @apply flex text-xs;
  color: var(--clrs-dynamic-entry-text-error);
}

.dynamic-entry-error-icon {
  fill: var(--clrs-dynamic-entry-error-icon);
}

.dynamic-entry-error-collapsed {
  @apply hidden;
}
